import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ClientDetails } from 'src/app/site/feature-modules/profile/models/profile';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule,TranslateModule],
  templateUrl: './menue.component.html',
  styleUrl: './menue.component.scss'
})
export class MenueComponent {
  @Input() clientDetails$: Observable<ClientDetails>; 
  @Output() onCloseMenu: EventEmitter<boolean> = new EventEmitter();
  @Output() onLogout: EventEmitter<boolean> = new EventEmitter();
  listOfLinks: {name: string, path: string}[] = [
    {name: 'profile.myProfile', path: '/booking/profile/my-profile'},
    {name: 'appointment.myAppointments', path: '/booking/profile/my-appointments'},
    {name: 'wallet.myWallet', path: '/booking/profile/my-wallet'},
    {name: 'Loyalty_point.myLoyaltyPoint', path: '/booking/profile/my-loyaltyPoint'},
    {name: 'gift.myGiftCards', path: '/booking/profile/my-giftCards'},
  ]
  constructor(
    private router:Router,
    public translate: TranslateService
  ) {

  }

  logOut(): void {
      this.onLogout.emit(true);
  }
  navigateToProfile(path:string): void {
    this.router.navigate([path]);
    this.onCloseMenu.emit(false);
  }
  
  closeMenu(): void {
    this.onCloseMenu.emit(false);
  }
}
